import { DataWriter } from "./DataWriter";
import { DataReader } from "./DataReader";
import { SerializationUtil } from "./SerializationUtil";

export type SegmentHeaderType = {
    version: Uint8Array | number[],
    segmentType: number,
    size: number,
    compressed: boolean
}

// Prefix header with %SPD
const segmentHeaderPrefix = new Uint8Array([0x25, 0x53, 0x50, 0x44]);

export class SegmentHeaderWriter extends DataWriter<SegmentHeaderType> {

    public write(header: SegmentHeaderType): Uint8Array {

        let buffer = new ArrayBuffer(1024); // kind of arbitrary size, hope that is enough (and not too much)

        let util = new SerializationUtil().writeTo(new DataView(buffer));

        if (!header.version || header.version.length != 3) {
            throw new Error(`Header version must consist of 3 numeric values`);
        }

        util
            .writeFixedUint8Array(segmentHeaderPrefix)
            .writeUint32(header.segmentType)
            .writeFixedUint8Array(header.version)
            .writeUint32(header.size)
            .writeBoolean(header.compressed);

        return util.finalize(false);
    }

}

export class SegmentHeaderReader extends DataReader<SegmentHeaderType> {

    public bytesRead: number;

    public read(data: Uint8Array): SegmentHeaderType {
        this.bytesRead = 0;
        let util = new SerializationUtil().readFrom(data, false);

        if (!this.validatePrefix(util.readFixedUint8Array(segmentHeaderPrefix.length))) {
            throw new Error(`Header does not contain the expected prefix`);
        }

        let header = {
            segmentType: util.readUint32(),
            version: util.readFixedUint8Array(3),
            size: util.readUint32(),
            compressed: util.readBoolean()
        };

        this.bytesRead = util.offset;
        return header;
    }

    private validatePrefix(data: Uint8Array): boolean {
        if (data.length != segmentHeaderPrefix.length) {
            return false;
        }

        for (let i = 0; i < segmentHeaderPrefix.length; i++) {
            if (segmentHeaderPrefix[i] != data[i]) {
                return false;
            }
        }

        return true;
    }
}